import { s as surfaceDarkStyles } from './surfaceDark-beb6179f.js';

const surfaceDarkInfoStyles = {
  ...surfaceDarkStyles,
  surface: {
    backgroundColor: '#018485'
  }
};
var surfaceDarkInfoStyles$1 = surfaceDarkInfoStyles;

export { surfaceDarkInfoStyles$1 as s };
//# sourceMappingURL=surfaceDarkInfo-c7ac00b4.js.map
